// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { Backup, PostRestoreBackupRequest, PostPutBackupRequest } from '@models/backups.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackupsService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };
  
  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getBackups(): Observable<Backup[]> {
    return this.http.get<Backup[]>(`${this.globalService.apiUrl.url}/Backups`, this.httpOptions);
  }

  postCreateBackup(postPutBackupRequest: PostPutBackupRequest): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Backups`, postPutBackupRequest, this.httpOptions);
  }

  getBackup(date: string): Observable<Backup> {
    return this.http.get<Backup>(`${this.globalService.apiUrl.url}/Backups/${date}`, this.httpOptions);
  }

  putEditBackup(date: string, postPutBackupRequest: PostPutBackupRequest): Observable<void> {
    return this.http.put<void>(`${this.globalService.apiUrl.url}/Backups/${date}`, postPutBackupRequest, this.httpOptions);
  }

  deleteBackup(date: string): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Backups/${date}`, this.httpOptions);
  }

  postRestaurarBackup(date: string, postRestoreBackupRequest: PostRestoreBackupRequest): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Backups/${date}/Restaurar`, postRestoreBackupRequest, this.httpOptions);
  }

  /**
   * Posibles valores de los parámetros:
   * - null  → se interpreta como "current" (estado actual en sistema)
   * - ''    → se interpreta como "edited" (estado modificado en cliente)
   * - valor → fecha en formato ISO string que identifica un backup
   */
  getBackupsComparar(item1: string | null, item2: string | null): Observable<unknown> {
    let params: HttpParams = new HttpParams();
    params = params.set('item1', item1 === null ? 'current' : (item1 === '' ? 'edited' : item1));
    params = params.set('item2', item2 === null ? 'current' : (item2 === '' ? 'edited' : item2));

    return this.http.get<unknown>(`${this.globalService.apiUrl.url}/Backups/Comparar`, { ...this.httpOptions, params });
  }
}